const routesService = {
	getHomePageRoute: (_) => "/home",
	getEntryPageRoute: (_) => "/",
	getNotFoundRoute: (_) => "/not-found",
	getLoginRoute: (_) => "/login",
};
export default routesService;
